import { render, staticRenderFns } from "./LensOverviewCardSkeleton.vue?vue&type=template&id=3a6ae6a5"
import script from "./LensOverviewCardSkeleton.vue?vue&type=script&lang=js"
export * from "./LensOverviewCardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports